import { render } from "./NFormError.vue?vue&type=template&id=f3b4b784&ts=true"
import script from "./NFormError.vue?vue&type=script&lang=ts"
export * from "./NFormError.vue?vue&type=script&lang=ts"

import "./NFormError.vue?vue&type=style&index=0&id=f3b4b784&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__